<template>
  <section>
    <b-row>
      <b-col>
        <div class="table-toolbar d-print-none" style="float: right">
          <a class="table-toolbar-control" @click="toolbar.open = !toolbar.open">
            <font-awesome-icon icon="bars" />
          </a>
          <div v-if="toolbar.open" class="table-toolbar-list">
            <a @click="download()"> Download Excel </a>
          </div>
        </div>

        <b-table striped hover responsive :items="filteredTableItems">
          <template v-slot:cell(Ripartizione)="data">
            <a
              class="jump"
              v-if="
                channels &&
                channels.find(
                  (c) => c.name == data.value && channels.find((childChannel) => childChannel.parent_code === c.code)
                )
              "
              v-scroll-to="scrollOptions(data.value)"
            >
              {{ data.value }}
            </a>
            <span v-else>{{ data.value }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="series == -1">
      <b-col v-if="load">
        <b-progress-bar :value="100" :max="100" variant="success" striped :animated="true">
          Caricamento dati in corso
        </b-progress-bar>
      </b-col>
    </b-row>

    <div ref="wrapper" class="main-chart-wrapper">
      <div class="main-chart mb-2">
        <div ref="wrapper-left" class="main-chart--expchild">
          <vue-resizable
            :fit-parent="false"
            :active="['r', 'b']"
            :min-width="273"
            :max-width="flexWidth"
            :min-height="250"
            @resize:end="onResizeEnd"
            v-if="load"
          >
            <div class="resizable-content a">
              <div
                :style="{
                  height: minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px`,
                  width: minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px`,
                }"
              >
                <div style="height: 100%" :id="pieChartId"></div>
              </div>
            </div>
          </vue-resizable>
        </div>
        <div class="main-chart--notexpchild">
          <div :style="{ height: `${minHeightDiv}px` }">
            <div style="height: 98%" :id="chartId"></div>
          </div>
        </div>
      </div>
    </div>

    <b-row v-if="series.length == []">
      <b-col>
        <b-alert :show="true" variant="warning">Nessun dato disponibile</b-alert>
      </b-col>
    </b-row>

    <template v-if="addChildren">
      <b-card
        :id="channel.name | slugify"
        :title="getTitle(channel)"
        v-for="(channel, index) in recursiveChannels"
        :key="channel.code"
      >
        <charts :vector="vector" :params="params" :parent="channel.code" :load="true" />
      </b-card>
    </template>
  </section>
</template>

<script>
import Vue from "vue";
var VueCookie = require("vue-cookie");
import { mapMutations } from "vuex";
import { makeid } from "./helpers";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { startRender, finishRender } from "../../helpers/printReady";

var moment = require("moment");

export default {
  name: "Charts",
  props: ["params", "parent", "vector", "categoryId", "recursive", "load"],
  created() {
    window.addEventListener("resize", this.resizeEventHandler);
  },
  data() {
    return {
      toolbar: {
        open: false,
      },
      mu: null,
      addChildren: false,
      pieOptions: {
        chart: {
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          toolbar: {
            show: true,
            tools: {
              download: true,
            },
          },
          width: "100%",
          height: "100%",
        },
        colors: this.$store.state.colors,
        labels: [],
        tooltip: {
          y: {
            formatter: (v) => {
              return v ? this.f(v) + (" " + `[${this.mu}]`) : "";
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        legend: {
          show: false,
        },
      },
      options: {
        colors: this.$store.state.colors,
        chart: {
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
          height: "100%",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return val ? val + "[kWh]" : "";
          },
        },
        xaxis: {
          //type: 'datetime',
          categories: [],
          labels: {
            rotate: -45,
          },
        },
        tooltip: {
          y: {
            formatter: (v) => {
              return v ? this.f(v) + " [kWh]" : "";
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (x) => this.f(x),
          },
        },
        legend: {
          formatter: (label) => this.getMu(label),
          position: "bottom",
          //offsetY: 40
          itemMargin: {
            vertical: 15,
          },
        },
        fill: {
          opacity: 1,
        },
      },
      series: -1,
      pieSeries: [],
      table: [],
      children: [],
      channels: [],
      recursiveChannels: [],
      parentHeight: 453,
      columnWidth: 339,
      chartWidth: 339,
      chartId: makeid(),
      pieChartId: makeid(),
      amBarChart: undefined,
      amPieChart: undefined,
      loaded: false,
      visibility: {},
      hiddenLegends: [],
    };
  },
  mounted() {
    // Initialize chart section width when page load
    this.resizeEventHandler();
    if (this.load) {
      this.refresh();
    }
  },
  methods: {
    ...mapMutations({
      startLoading: "loading",
      stopLoading: "stopLoading",
    }),

    visibilityChanged(isVisible, entry, key) {
      if (isVisible) {
        this.visibility[key] = isVisible;
        // this.$set(this.visibility, key, isVisible);
      }
    },

    getMu(name) {
      const channel = this.channels.find((c) => c.name == name);
      return channel ? `${channel.name} ${channel.mu}` : "";
    },

    resizeEventHandler(e) {
      let document = this.$refs["wrapper"];
      if (document !== undefined) {
        let result = document.clientWidth / 2;
        this.columnWidth = result;
      }
    },

    onResizeEnd(data) {
      if (data.eventName == "resize:end") {
        this.parentHeight = data.height;
        this.chartWidth = data.width;
      }
    },
    f(v) {
      if (v > 0 && v < 0.01) {
        v = 0.0;
      }
      if (v < 0 && v > -0.01) {
        v = 0.0;
      }
      return this.$options.filters.formatDecimal(v);
    },
    download() {
      let params = _.cloneDeep(this.params);
      params.vector = this.vector;
      params.parent = this.parent ? this.parent : "";
      params.categoryId = params.categoryId ? params.categoryId : 0;
      toolbar.open = false;
      location.href =
        process.env.API +
        "/data/monthly-tep-category/download?token=" +
        VueCookie.get("token") +
        "&from=" +
        params.fromMonth +
        "&to=" +
        params.toMonth +
        "&site=" +
        this.params.siteGuid +
        "&vector=" +
        params.vector +
        "&parent=" +
        params.parent +
        "&categoryId=" +
        params.categoryId;
    },
    getTitle(channel) {
      return channel.name + (channel.mu ? " [" + channel.mu + "]" : "");
    },
    refresh() {
      this.channels = this.$store.state.user.sites
        .find((s) => s.guid == this.params.siteGuid)
        .channels.filter((c) => c.data_model_id == 1);
      if (!this.params.siteGuid) {
        return;
      }

      let params = _.cloneDeep(this.params);
      params.vector = this.vector;
      if (this.categoryId > 0) params.categoryId = this.categoryId;
      else params.parent = this.parent;

      const isVectorAllocation = !params.parent && !params.categoryId;

      // this.startLoading();

      this.$store
        .dispatch("charts/monthlyTepCategory", params)
        .then((response) => {
          if (!response.data) {
            this.$notify({
              type: "error",
              text: response.message,
              title: "Errore",
            });
            return;
          }

          let data = response.data;

          this.table = [];
          this.series = [];
          this.pieSeries = [];
          this.mu = data.mu;

          let options = _.cloneDeep(this.options);
          let pieOptions = _.cloneDeep(this.pieOptions);

          pieOptions.labels = data.channels.map((c) => c);
          this.pieOptions = pieOptions;

          options.xaxis.categories = data.months.map((month) => {
            let m = month.split("-");
            let date = moment(m[1] + "-" + m[0] + "-01");
            return date.format("MMM YY");
          });

          this.options = options;
          this.series = [];

          data.channels.forEach((service) => {
            let row = {};

            if (this.recursive) {
              var channel = this.channels.find((c) => c.name == service);

              var children = _.filter(this.channels, (c) => c.parent_code == channel.code);
              if (children.length > 0) {
                this.recursiveChannels.push(channel);
              }
            }

            let title = "Ripartizione";
            row[title] = service + (this.parent == null && data.mu ? " [" + data.mu + "]" : "");
            row.name = service;
            row.hidden = false;

            var total = 0;
            var mu = "";
            data.months.forEach((month) => {
              let valueItem = data.values.find((v) => {
                return v[0] == service && v[1] == month;
              });

              let value = 0;
              try {
                value = valueItem ? valueItem[2].toFixed(2) : 0;
              } catch (e) {
                valueItem[2] = value;
              }
              let m = month.split("-");

              let date = moment(m[1] + "-" + m[0] + "-01");
              row[date.format("MMM YY")] = this.f(value);
              total += parseFloat(valueItem ? valueItem[2] : 0);
              mu = data.mu ? data.mu : mu;
            });

            row.Totale = this.f(total);

            this.table.push(row);
          });

          data.channels.forEach((service) => {
            let serie = {
              name: service,
              data: [],
            };
            data.months.forEach((month) => {
              let value = data.values.find((v) => {
                return v[0] == service && v[1] == month;
              });
              serie.data.push(value ? value[2] : 0);
            });

            this.series.push(serie);
          });

          data.channels.forEach((service) => {
            var total = 0;
            data.months.forEach((month) => {
              let value = data.values.find((v) => {
                return v[0] == service && v[1] == month;
              });
              total += value ? value[2] : 0;
            });

            this.pieSeries.push(total);
          });
          this.setAmChartsData(data);

          Vue.nextTick(() => {
            this.addChildren = this.recursiveChannels.length > 0;
          });
        })
        .finally(() => {});
    },
    scrollOptions(name) {
      return {
        el: "#" + Vue.filter("slugify")(name),
        offset: -100,
      };
    },
    setAmChartsData(respData) {
      let chartData = {
        mus: [""],
        columns: ["Date"],
        sources: [],
        values: respData.months.map((mon) => [mon]),
      };
      respData.values.forEach((ele, index) => {
        if (!chartData.columns.includes(ele[0])) {
          chartData.columns.push(ele[0]);
          chartData.sources.push("EE_12" + index);
        }
      });

      let pieData = [];

      for (let i = 1; i < chartData.columns.length; i++) {
        let column = chartData.columns[i];
        let pieValue = {
          name: column,
          value: 0,
        };
        for (let j = 0; j < respData.months.length; j++) {
          let value = respData.values.find((ele, valueIndex) => {
            if (ele[0] == column && ele[1] == respData.months[j]) {
              return ele;
            }
          });
          if (i == 1) {
            let d = chartData.values[j][0].split("-");
            let date = `${d[1]}-${d[0]}-01`;
            chartData.values[j][0] = new Date(date);
          }

          let calValue = value[2] ? Number(value[2].toFixed(2)) : 0;
          chartData.values[j].push(calValue);
          pieValue.value += calValue;
        }
        pieData.push(pieValue);
      }
      this.makeChart(this.chartId, chartData);
      this.makeAmPieChart(pieData);
    },
    makeChart(chartId, data) {
      this.colors = this.$store.state.colors;
      let chart = am4core.create(chartId, am4charts.XYChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.colors.list = this.colors.map((e) => {
        return am4core.color(e);
      });
      chart.fontSize = 10;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());

      dateAxis.cursorTooltipEnabled = false;
      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.renderer.minGridDistance = 30;
      dateAxis.renderer.cellStartLocation = 0.2;
      dateAxis.renderer.cellEndLocation = 0.8;

      dateAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
        if (target.dataItem.value) {
          let labelValue = target.dataItem.value;

          let formattedDate = moment(labelValue).format("MMM YY");
          return formattedDate;
        }
      });

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.legend = new am4charts.Legend();
      chart.exporting.menu = new am4core.ExportMenu();
      chart.series.clear();
      chart.legend.itemContainers.template.events.on("hit", (ev) => {
        let table = [...this.table];

        let name = ev.target.dataItem.dataContext.name;
        if (this.hiddenLegends.includes(name)) {
          let index = this.hiddenLegends.indexOf((ele) => ele == name);
          this.hiddenLegends.splice(index, 1);
        } else {
          this.hiddenLegends.push(name);
        }

        let newTable = table.map((ele) => {
          ele.hidden = this.hiddenLegends.includes(ele.name) ? true : false;
          return ele;
        });
        this.table = newTable;
        // let seriesColumn = ev.target.dataItem.dataContext.columns.template;
        // seriesColumn.isActive = !seriesColumn.isActive;
      });

      this.yAxis = {};
      data.mus.forEach((mu, index) => {
        if (!this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.min = 0;
          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = "";
          valueAxis.title.fontWeight = 600;
          valueAxis.cursorTooltipEnabled = false;
          this.yAxis[mu] = valueAxis;
        }
      });
      this.createSeries(data, chart);
    },

    createSeries(data, chart) {
      data.sources.forEach((source, index) => {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = source;
        series.tooltip.pointerOrientation = "vertical";
        series.name = data.columns[index + 1];
        series.dataFields.dateX = "date";
        series.columns.template.width = am4core.percent(100);
        series.stacked = true;
        series.tooltip.getFillFromObject = false;
        series.tooltip.autoTextColor = false;
        series.adapter.add("tooltipText", (text, target) => {
          let tooltipData = target.tooltipDataItem.dataContext;
          var sum = target.tooltipDataItem.dataContext.value;
          var seriesData = [];
          seriesData.push(sum.toString().split("."));
          var valueY = seriesData[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
          let strokeColor = target.stroke.hex;
          let dateFormat = this.getTooltipFormat();
          var text = `${dateFormat}  \n [${strokeColor}]● [/]  ${tooltipData.name} [bold] ${valueY}[/]`;
          return text;
        });

        series.tooltip.label.fill = am4core.color("black");
        var series_data = [];

        data.values.forEach((item, valueIndex) => {
          var dataItem = {};
          dataItem.value = item[index + 1] ? item[index + 1].toFixed(2) : 0;
          dataItem.name = data.columns[index + 1];
          dataItem.date = item[0];
          dataItem[source] = item[index + 1];
          series_data.push(dataItem);
        });
        series.data = series_data;
      });
      this.amBarChart = chart;
    },

    getTooltipFormat() {
      return '{dateX.formatDate("MMM YYYY")}';
    },

    makeAmPieChart(data) {
      var chart = am4core.create(this.pieChartId, am4charts.PieChart);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let pieRenderSettled = false;
      const settlePieRender = () => {
        if (pieRenderSettled) return;
        pieRenderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settlePieRender);
      setTimeout(settlePieRender, 8000);

      chart.data = data;
      chart.fontSize = 10;
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";

      var pieSeries = chart.series.push(new am4charts.PieSeries());

      pieSeries.labels.template.maxWidth = 130;
      pieSeries.labels.template.wrap = true;
      pieSeries.labels.template.fontSize = 11;
      pieSeries.defaultState.animationDuration = 0;
      pieSeries.defaultState.interpolationDuration = 0;
      pieSeries.defaultState.transitionDuration = 0;
      pieSeries.defaultState.rangeChangeDuration = 0;
      pieSeries.hiddenState.animationDuration = 0;
      pieSeries.hiddenState.interpolationDuration = 0;
      pieSeries.hiddenState.transitionDuration = 0;
      pieSeries.hiddenState.rangeChangeDuration = 0;

      chart.radius = am4core.percent(50);

      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "name";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      //pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.tooltip.getFillFromObject = false;
      pieSeries.tooltip.autoTextColor = false;
      pieSeries.tooltip.label.fill = am4core.color("black");

      // This creates initial animation

      var colorSet = new am4core.ColorSet();
      colorSet.list = this.colors.map(function (color) {
        return new am4core.color(color);
      });
      pieSeries.colors = colorSet;

      pieSeries.ticks.template.disabled = false;
      pieSeries.alignLabels = true;
      pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
      pieSeries.labels.template.radius = am4core.percent(0);
      //pieSeries.labels.template.fill = am4core.color("white");

      pieSeries.slices.template.tooltipText = `{category}: [bold] {value} [[KWH]]`;

      var hs = pieSeries.slices.template.states.getKey("hover");
      hs.properties.scale = 1;

      chart.hiddenState.properties.radius = am4core.percent(0);
      this.amPieChart = chart;
    },

    unload() {
      if (this.amBarChart) {
        this.amBarChart.dispose();
        this.amBarChart = undefined;
      }
      if (this.amPieChart) {
        this.amPieChart.dispose();
        this.amPieChart = undefined;
      }
    },
  },
  computed: {
    monthLabels() {
      return "Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic".split("_");
    },
    minHeightDiv() {
      return this.parentHeight;
    },
    chartWidthValue() {
      return this.chartWidth;
    },
    flexWidth() {
      return this.columnWidth;
    },
    filteredTableItems() {
      let tableCopy = _.cloneDeep(this.table);
      let newTableData = tableCopy
        .filter((ele) => !ele.hidden)
        .map((ele) => {
          delete ele.hidden;
          delete ele.name;
          return ele;
        });
      return newTableData;
    },
  },
  watch: {
    params() {
      this.refresh();
    },
    load(value) {
      if (value && !this.loaded) {
        this.loaded = true;
        this.refresh();
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
    this.unload();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeEventHandler);
    this.unload();
  },
};
</script>

<style>
.table td,
.table th {
  font-size: 12px;
}

.table .jump {
  border-bottom: 1px dotted #666;
  cursor: pointer;
}

.main-chart-wrapper {
  overflow: hidden;
}

.main-chart {
  display: flex;
  flex-direction: row;
}

.main-chart .main-chart--expchild {
  flex: 0 1 auto;
}

.main-chart .main-chart--notexpchild {
  flex-grow: 1;
  max-height: 100%;
}

.a + .resizable-r {
  z-index: 0 !important;
  height: 80px !important;
  background-color: #d0dae3 !important;
  top: 50% !important;
  transform: translateY(-50%);
}

.resizable-b {
  z-index: 0 !important;
  background-color: #d0dae3 !important;
  height: 3px !important;
  bottom: 0 !important;
  left: 100% !important;
  width: 80px !important;
  transform: translateX(100%);
}

.resizable-content {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Diagnosi/Charts.vue